var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAgentComputerInterface(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_884)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.50008 5.49996V4.58329C5.50008 1.83329 6.87508 0.916626 9.16675 0.916626H12.8334C15.1251 0.916626 16.5001 2.29163 16.5001 4.58329V5.49996C19.2501 5.49996 21.0834 7.33329 21.0834 10.0833C21.0834 12.8333 19.2501 14.6666 16.5001 14.6666M5.50008 5.49996H12.8334M5.50008 5.49996C2.75008 5.49996 0.916748 6.87496 0.916748 10.0833C0.916748 13.2916 2.75008 14.6666 5.50008 14.6666M11.0001 17.4166V21.0833M8.25008 21.0833H13.7501M7.33341 17.4166H14.6667V11H7.33341V17.4166Z",
    stroke: "black",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_884"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgentComputerInterface);
export default __webpack_public_path__ + "static/media/agent-computer-interface.a717ad44ecd34ad9884834552fe3354d.svg";
export { ForwardRef as ReactComponent };